import { i18n } from '../../main'
import firebase from 'firebase/app'
import router from '../../router'
import { API_MASTER_DATA, S3_PUBLIC_PATH, AUTH_TESTING } from '../../service/index'
import axios from 'axios'

export const AUTH_ERRORS = {
  'auth/too-many-requests': 'storeauth.error1',
  'auth/invalid-phone-number': 'storeauth.error2',
  'auth/invalid-verification-code': 'storeauth.error5',
  'auth/code-expired': 'storeauth.error6',
  'default': 'storeauth.error7'
}

export default {
  state: {
    UserLogin: null,
    UserInfo: null,
    UserLineInfo: null,
    UserToken: null
  },
  mutations: {
    setUserLogin(state, payload) {
      state.UserLogin = payload
    },
    setUserInfo(state, payload) {
      state.UserInfo = payload
    },
    setUserLineInfo(state, payload) {
      state.UserLineInfo = payload
    }
  },
  actions: {
    async recheckStampUserLine({commit, state}, payload) {
      await axios({
        method: 'POST',
        url: API_MASTER_DATA + 'users/user-line',
        headers: { Authorization: state.UserToken },
        data: {
          user_line_id: payload.profile.userId,
          restaurant_uuid: payload.restaurant_uuid
        }
      }).then((response) => {
        if (response.data.meta.status === 200) {
          commit('setUserLineInfo', response.data.data)
        } else {
          commit('setUserLineInfo', null)
        }
      }).catch((err) => {
        commit('setUserLineInfo', null)
      })
    },
    getUserInfo({commit, state}, payload) {
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
        // console.log(idToken)
        state.UserToken = idToken
        axios({
          method: 'GET',
          url: API_MASTER_DATA + 'users',
          headers: { Authorization: idToken }
        }).then((response) => {
          if (response.data.meta.status === 200) {
            commit('setUserInfo', response.data.data)
          } else {
            commit('setUserInfo', null)
          }
        }).catch((err) => {
          commit('setUserInfo', null)
        })
      })
    },
    getNewUser() {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
          axios({
            method: 'GET',
            url: API_MASTER_DATA + 'users/login',
            headers: { Authorization: idToken }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              if (response.data.data.isNewUser) {
                resolve(true)
              } else {
                resolve(false)
              }
            } else {
              resolve(false)
            }
          }).catch((err) => {
            resolve(false)
          })
        })
      })
    },
    getUserToken({ commit, dispatch }, payload) {
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
        axios({
          method: 'GET',
          url: API_MASTER_DATA + 'users/login',
          headers: { Authorization: idToken }
        }).then((response) => {
          if (response.data.meta.status === 200) {
            if (response.data.data.isNewUser) {
              router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/verify/info` })
            } else {
              router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/checkout` })
            }
          }
        }).catch(() => {
          router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/checkout` })
        })
      }).catch(function () {
        router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/checkout` })
      })
    },
    updateUserInfo({ commit }, payload) {
      return new Promise(function (resolve, reject) {
        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
          axios({
            method: 'PATCH',
            url: API_MASTER_DATA + 'users',
            headers: { Authorization: idToken },
            data: { displayName: payload.username, imageKey: '' }
          }).then((response) => {
            if (response.data.meta.status === 200) {
              window.location = `/restaurant/${payload.restaurant_uuid}/${payload.branch_uuid}/checkout`
            } else {
              resolve(false)
            }
          }).catch(() => {
            resolve(false)
          })
        })
      })
    },
    onAuthStateChanged({ commit, state }) {
      return new Promise(function (resolve, reject) {
        firebase.auth().onAuthStateChanged(function (user) {
          if (user) {
            commit('setUserLogin', true)
            resolve(true)
          } else {
            commit('setUserLogin', false)
            resolve(false)
          }
        })
      })
    },
    verifyPhoneNumber: async function({ commit }, payload) {
      await firebase.auth().signOut()
      // Turn off phone auth app verification.
      firebase.auth().settings.appVerificationDisabledForTesting = AUTH_TESTING
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
        'size': 'invisible',
        'callback': function (_) {
          onSignInSubmit();
        }
      })
      window.recaptchaVerifier.render()

      try {
        const { verificationId = ' '} = await firebase
          .auth()
          .signInWithPhoneNumber(payload.phoneNumber, window.recaptchaVerifier)
        return router.push({
          name: 'AuthPhoneNumberOTP',
          params: {
            restaurant_uuid: payload.restaurantAlias,
            branch_uuid: payload.branchAlias
          },
          query: {
            phoneNumber: payload.phoneNumber,
            verificationId: verificationId
          }
        })
      } catch (error) {
        throw new Error(i18n.t(AUTH_ERRORS[error.code] || AUTH_ERRORS.default))
      }
      // firebase.auth().signInWithPhoneNumber(payload.phoneNumber, window.recaptchaVerifier).then(function (confirmationResult) {
      //   router.push({
      //     path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/verify/otp`,
      //     query: {
      //       PhoneNumber: payload.phoneNumber,
      //       verificationId: confirmationResult.verificationId
      //     }
      //   })
      // })
      //   .catch(function (error) {
      //     if (error.code === 'auth/too-many-requests') {
      //       alert(i18n.t('storeauth.error1'))
      //       router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/checkout` })
      //     } else if (error.code === 'auth/invalid-phone-number') {
      //       alert(i18n.t('storeauth.error2'))
      //       router.go(0)
      //     } else if (error.code === 'auth/code-expired') {
      //       alert(i18n.t('storeauth.error3'))
      //       router.go(0)
      //     } else {
      //       alert('เกิดข้อผิดพลาดในการ ' + error.message + ' กรุณาลองใหม่')
      //       router.go(0)
      //     }
      //   })
    },
    verifyCodeOTP: async function({ dispatch }, payload) {
      await firebase.auth().signOut()
      
      // Turn off phone auth app verification.
      firebase.auth().settings.appVerificationDisabledForTesting = AUTH_TESTING
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
        'size': 'invisible',
        'callback': function (_) {
          onSignInSubmit();
        }
      })
      
      try {
        const credential = firebase.auth.PhoneAuthProvider.credential(payload.verificationId, payload.numberOTP)
        const user = await firebase.auth().signInWithCredential(credential)
        const phoneNumber = user.user.phoneNumber.replace('+66','0')
        showPolicy(phoneNumber)
        return dispatch('getUserToken', {
          restaurantAlias: payload.restaurantAlias,
          branchAlias: payload.branchAlias,
          user: user
        })
      } catch (error) {
        throw new Error(i18n.t(AUTH_ERRORS[error.code] || AUTH_ERRORS.default))
      }
      
      // try {
      //   let credential = firebase.auth.PhoneAuthProvider.credential(payload.verificationId, payload.numberOTP)
      //   // https://firebase.google.com/docs/reference/js/firebase.auth.Auth?hl=th#signinwithcredential
      //   firebase.auth().signInWithCredential(credential).then(function (user) {
      //     dispatch('getUserToken', {
      //       restaurantAlias: payload.restaurantAlias,
      //       branchAlias: payload.branchAlias,
      //       user: user
      //     })
      //   }).catch(function (error) {
      //     let errorCode = error.code
      //     // console.log(error.code)
      //     if (errorCode === 'auth/invalid-verification-code') {
      //       alert(i18n.t('storeauth.error5'))
      //       router.go(0)
      //     } else if (errorCode === 'auth/code-expired') {
      //       // dispatch('getUserToken', user)
      //       alert(i18n.t('storeauth.error6'))
      //       router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/verify/phonenumber` })
      //     } else {
      //       router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/verify/phonenumber` })
      //     }
      //   })
      // } catch (err) {
      //   alert(i18n.t('storeauth.error7'))
      //   router.push({ path: `/restaurant/${payload.restaurantAlias}/${payload.branchAlias}/verify/phonenumber` })
      // }
    }
  },
  getters: {
    UserLogin(state) {
      return state.UserLogin
    },
    UserInfo(state) {
      return state.UserInfo
    },
    UserLineInfo(state) {
      return state.UserLineInfo
    },
    UserToken (state) {
      return state.UserToken
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js